import React, { useEffect, useState } from "react";
import Select from "react-select";
import { PageTitle } from "../PageTitle";
import { InventoryService } from "../../services";
import i18next from "i18next";
import { Alert } from "react-bootstrap";

const InventoryBulkAdd = () => {
    const [loading, setLoading] = useState(false);
    const [availableDeviceTypes, setAvailableDeviceTypes] = useState([]);
    const [selectedDeviceType, setSelectedDeviceType] = useState(null);
    const [template, setTemplate] = useState(null);
    const [csvUpload, setCsvUpload] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);

    useEffect(() => {
        setLoading(true);

        let requests = [];

        requests.push(InventoryService.getSupportedDeviceTypeTemplates());

        Promise.all(requests)
            .then((results) => {
                setLoading(false);
                results.forEach((result) => {
                    if (result.deviceTypeTemplates) {
                        setAvailableDeviceTypes(
                            result.deviceTypeTemplates
                                .filter((deviceTypeTemplate) => deviceTypeTemplate.allowBulk == true)
                                .map((deviceTypeTemplate) => ({ value: deviceTypeTemplate.deviceTypeToken, label: deviceTypeTemplate.deviceTypeName, deviceTypeTemplate: deviceTypeTemplate }))
                        );
                    }
                });
            })
            .catch((err) => {
                setLoading(false);
                console.error(err);
            });
    }, []);

    useEffect(() => {
        if (selectedDeviceType) {
            setTemplate(selectedDeviceType.deviceTypeTemplate);
        }
    }, [selectedDeviceType]);

    const handleSave = () => {
        setLoading(true);
        setSuccessMessage(null);
        setErrorMessage(null);

        const formData = new FormData();
        formData.append("uploadedCSV", csvUpload);

        InventoryService.addBulkInventory(selectedDeviceType.value, formData)
            .then(({ inventory }) => {
                console.log(inventory);
                
                setSuccessMessage(
                    <span>
                        Inventory record added.{" "}
                        <button className="btn btn-sm btn-primary pull-right" onClick={() => setSuccessMessage(null)}>
                            X
                        </button>
                    </span>
                );
                setLoading(false);
                setCsvUpload(null);
            })
            .catch((err) => {
                console.error(err);
                if (err.response?.data) {
                    setErrorMessage(`Unable to save inventory data: ${err.response?.data}`);
                } else {
                    setErrorMessage(`Unable to save inventory data: ${err}`);
                }
                setLoading(false);
                setCsvUpload(null);
            });
    };    

    return (
        <div>
            <div className="row">
                <PageTitle title="Inventory Bulk Add" />
            </div>
            <div className="inner op-content-box">
                <div className="row">
                    <div className="col-lg-12">
                        {errorMessage && (
                            <Alert className="col-sm-12 col-md-10 col-lg-10 alert-danger">
                                {errorMessage}
                                <button className="btn btn-sm btn-primary pull-right" onClick={() => setErrorMessage(null)}>
                                    X
                                </button>
                            </Alert>
                        )}
                        {successMessage && <Alert className="col-sm-12 col-md-10 col-lg-10 alert-success">{successMessage}</Alert>}

                        {loading && <div className="loader">Loading...</div>}

                        {!loading && (
                            <div className="row">
                                <div className="col-sm-12 col-md-6 col-lg-6">
                                    <label>Device Type</label>
                                    <Select
                                        options={availableDeviceTypes}
                                        value={selectedDeviceType}
                                        onChange={setSelectedDeviceType}
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder={i18next.t("select")}
                                    />
                                </div>
                            </div>
                        )}
                        {!loading && selectedDeviceType && template && (
                            <div>
                                <div className="row" style={{paddingTop: 10}}>
                                    <div className="col-sm-12 col-md-12 col-lg-12">
                                        Required CSV header: {template.bulkHeaderFormat} <br />
                                    </div>
                                </div>
                                <div className="row" style={{paddingTop: 10}}>
                                    <div className="col-sm-12 col-md-12 col-lg-12">
                                        <label>CSV File:</label>
                                        <input
                                            type="file"
                                            name="csv_data"
                                            onChange={({ target }) => setCsvUpload(target.files[0])}
                                            className="input-sm form-control"                                    
                                        />
                                    </div>
                                </div>
                                <div className="row" style={{paddingTop: 10}}>
                                    <div className="col-sm-12 col-md-12 col-lg-12">
                                        <button className="btn btn-sm btn-primary pull-right" onClick={handleSave} disabled={csvUpload == null}>Save</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InventoryBulkAdd;